import axios from './../../../config/apiConfig';
import { React, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import NavigationUser from '../../common/navigationUser/NavigationUser';
import style from './hallWithStands.module.scss';
import DisplayStandsForWeb from '../../utils/DisplayStandsForWeb';
import Navegation from '../../common/navegationHome/Navegation';

const HallWithStands = () => {
  const { hall } = useParams();
  const history = useHistory();
  const { hallContainer, hallPos } = style;
  const [occupedStands, setOccupedStands] = useState([]);
  const [requestState, setRequestState] = useState('noReq');
  const [translatedHall, setTranslatedHall] = useState('');
  const [standPage, setStandPage] = useState(1);
  const [supNav, setSupNav] = useState(false);

  useEffect(() => {
    if (hall !== 'dermocosmetics' && hall !== 'perfumery' && hall !== 'medicaments') {
      history.push('/');
    }
    const role = localStorage.getItem('role');
    if (role === 'supplier') {
      setSupNav(true);
    }
  }, []);

  useEffect(async () => {
    try {
      const hallOpt = {
        perfumery: 'perfume', 
        dermocosmetics: 'cosmetic', 
        medicaments: 'medicine' 
      };
      setTranslatedHall(hallOpt[hall]);
      setRequestState('noReq');
      const opt = {
        perfumery: 'perfumeria', 
        dermocosmetics: 'dermocosmetica', 
        medicaments: 'medicamentos' 
      };
      const { data } = await axios.get(`/stands?section=${opt[hall]}`);
      setRequestState(data.status);
      setOccupedStands(data.data);
      const idsFilter = data.data.map((st) => {
        if (st._id) {
          return st._id;
        }
      });
      const standsJson = JSON.stringify(idsFilter);
      localStorage.setItem('stands', standsJson);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  }, [hall]);

  const triggerStand = (data) => {
    history.push(`${hall}/${data._id}`);
  };

  return (
    <>
      {supNav ? <Navegation /> : <NavigationUser/>}
      <div className={hallPos}>
        <div className={hallContainer} id="imgContainer">
          <DisplayStandsForWeb
            occupedStands={occupedStands}
            hall={translatedHall}
            hallState={requestState}
            standPage={standPage}
            setStandPage={setStandPage}
            handleShowModal={triggerStand}
          />
        </div>
      </div>
    </>
  );
};

export default HallWithStands;
